<template>
  <h3 class="text-lg font-semibold leading-none tracking-tight">
    <slot></slot>
  </h3>
</template> 